import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";
import {
  CMS_FORM_SELECT_TRIGGER_CLASS,
  CMS_SEPARATOR_TYPES,
  type CmsColor,
  type CmsSeparatorType,
} from "@/lib/cms/cms-theme.constants";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { PaletteColorPicker } from "./PaletteColorPicker";

type Props = {
  colors: CmsColor[];
  separatorType: CmsSeparatorType;
  separatorColorId: string | null | undefined;
  onSeparatorTypeChange: (type: CmsSeparatorType) => void;
  onSeparatorColorChange: (id: string | null) => void;
  onColorsChange?: (colors: CmsColor[]) => void;
};

export function SeparatorStyleFields({
  colors,
  separatorType,
  separatorColorId,
  onSeparatorTypeChange,
  onSeparatorColorChange,
  onColorsChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-2">
        <Label>{t("cms.appearance.separator.type")}</Label>
        <Select
          value={separatorType}
          onValueChange={(v) =>
            onSeparatorTypeChange(v as CmsSeparatorType)
          }
        >
          <SelectTrigger className={cn(CMS_FORM_SELECT_TRIGGER_CLASS)}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {CMS_SEPARATOR_TYPES.map((type) => (
              <SelectItem key={type} value={type}>
                {t(`cms.appearance.separator.${type.toLowerCase()}`)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {separatorType !== "NONE" && (
        <PaletteColorPicker
          label={t("cms.appearance.separator.color")}
          colors={colors}
          value={separatorColorId}
          onColorsChange={onColorsChange}
          onChange={onSeparatorColorChange}
        />
      )}
    </div>
  );
}
